// components/EmailList.js
import React from "react";
import { Checkbox, IconButton } from "@material-ui/core";
import DeleteIcon from "@mui/icons-material/Delete";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import DraftsIcon from "@mui/icons-material/Drafts";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import moment from "moment";

const EmailList = ({
  emails,
  selectedEmails,
  selectedEmail,
  onEmailClick,
  onSelectEmail,
  onSelectAll,
  onStarToggle,
  onMarkAsRead,
  onMarkAsUnread,
  onDelete,
  searchTerm,
}) => {
  const formatTime = timestamp => {
    const now = moment();
    const emailTime = moment(timestamp);

    if (now.diff(emailTime, "days") < 1) {
      return emailTime.format("h:mm A");
    } else if (now.diff(emailTime, "days") < 7) {
      return emailTime.format("ddd");
    } else {
      return emailTime.format("MMM D");
    }
  };

  if (emails.length === 0) {
    return (
      <div className='email-list'>
        <div className='empty-inbox'>
          <p>{searchTerm ? "No emails found" : "No emails"}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {selectedEmails.length > 0 && (
        <div className='selection-toolbar'>
          <Checkbox
            checked={selectedEmails.length === emails.length}
            onChange={onSelectAll}
            indeterminate={
              selectedEmails.length > 0 && selectedEmails.length < emails.length
            }
          />
          <span className='selected-count'>
            {selectedEmails.length} selected
          </span>
          <div className='selection-actions'>
            <IconButton
              onClick={onMarkAsRead}
              title='Mark as read'
              size='small'>
              <DraftsIcon />
            </IconButton>
            <IconButton
              onClick={onMarkAsUnread}
              title='Mark as unread'
              size='small'>
              <MarkunreadIcon />
            </IconButton>
            <IconButton onClick={onDelete} title='Delete' size='small'>
              <DeleteIcon />
            </IconButton>
          </div>
        </div>
      )}

      <div className='email-list'>
        {emails.map(email => (
          <div
            key={email.id || email.messageId}
            className={`email-item ${email.isRead ? "read" : "unread"} ${
              selectedEmail?.id === email.id ? "selected" : ""
            }`}
            onClick={() => onEmailClick(email)}>
            <div className='email-select' onClick={e => e.stopPropagation()}>
              <Checkbox
                checked={selectedEmails.includes(email.id)}
                onChange={e => onSelectEmail(email.id, e)}
              />
            </div>
            <div
              className='email-star'
              onClick={e => onStarToggle(email.id, e)}>
              {email.isStarred ? (
                <StarIcon style={{ color: "#fbbc05" }} />
              ) : (
                <StarBorderIcon />
              )}
            </div>
            <div className='email-sender'>
              <span className='sender-name'>
                {email.isRead ? (
                  email.fromName
                ) : (
                  <strong>{email.fromName}</strong>
                )}
              </span>
            </div>
            <div className='email-content'>
              <div className='email-subject-line'>
                <span className='email-subject'>
                  {email.isRead ? (
                    email.subject
                  ) : (
                    <strong>{email.subject}</strong>
                  )}
                </span>
                <span className='email-preview'>{email.preview}</span>
              </div>
              <div className='email-meta'>
                <span className='email-time'>
                  {formatTime(email.timestamp)}
                </span>
                {email.attachments && email.attachments.length > 0 && (
                  <span className='attachment-indicator'>
                    <AttachFileIcon fontSize='small' />
                    {email.attachments.length > 1 && (
                      <span className='attachment-count'>
                        {email.attachments.length}
                      </span>
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default EmailList;
